import React from "react";

import { namePatternMatch } from "../../../utilities/helpers";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";

import { InfoIcon } from "../../InfoIcon";
import { PasswordInput } from "../../PasswordInput";
import { Error } from "../../Error";
import { Success } from "../../Success";
import { Spinner } from "../../LoadingContainer/Spinner";

import "./security.scss";

export default function Security({
  info,
  handleInfo,
  handleUpdate,
  handleInput,
  passwordRef,
  error,
  success,
  isNameDisabled,
  isSavingName,
  isEmailDisabled,
  isSavingEmail,
  isPasswordDisabled,
  isSavingPassword,
}) {
  return (
    <div id="security">
      <div className="section-header">
        <h1 className="normal">Personal details</h1>
        <span className="subtitle">
          This information is not visible to the public.
        </span>
      </div>
      <Form className="form-group">
        <Row>
          <Col>
            <Form.Group controlId="firstName">
              <Form.Label>First name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                placeholder="Enter first name"
                pattern={namePatternMatch}
                value={info.firstName}
                onChange={(e) =>
                  handleInfo(
                    e.target.validity.valid || e.target.value === ""
                      ? e
                      : info.firstName,
                  )
                }
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="lastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                placeholder="Enter last name"
                pattern={namePatternMatch}
                value={info.lastName}
                onChange={(e) =>
                  handleInfo(
                    e.target.validity.valid || e.target.value === ""
                      ? e
                      : info.lastName,
                  )
                }
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Button
          variant="outline-light"
          size="lg"
          className="update-btn mt-4"
          disabled={isNameDisabled || isSavingName}
          onClick={() => handleUpdate("name")}
        >
          {isSavingName ? <Spinner variant="dark" /> : "Update name"}
        </Button>
        {success.includes("name") && <Success field="name" />}
      </Form>
      <Form className="form-group">
        <fieldset>
          <legend>Change email</legend>
          <Row>
            <Col>
              <Form.Group controlId="curEmail">
                <Form.Label>Current email</Form.Label>
                <Form.Control
                  type="email"
                  name="curEmail"
                  placeholder="Enter current email"
                  disabled
                  value={info.curEmail}
                  onBlur={handleInput}
                  onChange={handleInfo}
                  required
                  className={`${error?.field === "current email" ? "error-border" : ""}`}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="email">
                <Form.Label>New Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter new email"
                  value={info.email}
                  onChange={handleInfo}
                  onBlur={handleInput}
                  required
                  className={`${error?.field === "new email" ? "error-border" : ""}`}
                />
              </Form.Group>
            </Col>
          </Row>
        </fieldset>
        {error?.field?.includes("email") && (
          <Error field={error.field} type={error.type} />
        )}
        <Button
          variant="outline-light"
          size="lg"
          className="update-btn mt-4"
          disabled={
            error?.field === "new email" || isEmailDisabled || isSavingEmail
          }
          onClick={() => handleUpdate("email")}
        >
          {isSavingEmail ? <Spinner variant="dark" /> : "Update email"}
        </Button>

        {success.includes("email") && <Success field="email" />}
      </Form>
      <Form className="form-group">
        <fieldset>
          <legend>Change password</legend>
          <Row>
            <Col>
              <Form.Group controlId="curPassword">
                <Form.Label>Current password</Form.Label>
                <PasswordInput
                  name="curPassword"
                  placeholder="Enter current password"
                  value={info.curPassword}
                  handlePassword={handleInfo}
                  onBlur={handleInput}
                  isValid={error?.field !== "current password"}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="password">
                <div className="form-label--flex">
                  <Form.Label>New password</Form.Label>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Minimum 6 characters</Tooltip>}
                  >
                    <Button variant="link">
                      <InfoIcon />
                    </Button>
                  </OverlayTrigger>
                </div>
                <PasswordInput
                  reference={passwordRef}
                  name="password"
                  placeholder="Enter new password"
                  value={info.password}
                  handlePassword={handleInfo}
                  onBlur={handleInput}
                  isValid={error?.field !== "new password"}
                />
              </Form.Group>
            </Col>
          </Row>
        </fieldset>
        {error?.field?.includes("password") && (
          <Error field={error.field} type={error.type} />
        )}
        <Button
          variant="outline-light"
          size="lg"
          className="update-btn mt-4"
          disabled={
            error?.field === "new password" ||
            isPasswordDisabled ||
            isSavingPassword
          }
          onClick={() => handleUpdate("password")}
        >
          {isSavingPassword ? <Spinner variant="dark" /> : "Update password"}
        </Button>

        {success.includes("password") && <Success field="password" />}
      </Form>
    </div>
  );
}
